import { Link } from 'react-router-dom';

import PageWrapper from '@/components/atoms/PageWrapper';
import { Button } from '@/components/ui/button';


export default function NotFoundPage() {
    return (
        <>
            <PageWrapper>
                <div className="h-full flex flex-col md:flex-row justify-center items-center md:space-x-20" style={{minHeight: "calc(100vh - 66px - 16px)"}}>

                    <div className="space-y-10">
                        <div>
                            <div className="text-6xl font-bold mb-1">404</div>   
                            <hr></hr> 
                        </div>
                        
                        <div className="sm:text-2xl">
                            Sorry, the page you are<br/> looking for could not be found
                        </div>
                        <div>
                            <Link to="/">
                                <Button className="w-full sm:w-auto">Back</Button>
                            </Link>
                        </div>
                    </div>

                    <div className="order-[-1] md:order-last mb-10">
                        <div className="font-bold text-4xl md:text-5xl lg:text-[100px] text-[#10306A]">Collaborate</div>
                    </div>
                </div>
            </PageWrapper>
        </>
    )
}
